import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import useIsMobile from "components/hooks/useIsMobile";
import { SxProps } from "@mui/system";

interface UnpaidTrialBannerProps {
  daysLeft: number;
  sx?: SxProps;
}

export default ({ daysLeft, sx }: UnpaidTrialBannerProps) => {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  const handleFinishSignup = () => {
    navigate("/upgrade-select");
  };

  return (
    <Box
      sx={{
        position: "relative",
        backgroundColor: "#198282",
        padding: isMobile ? "16px" : "16px 24px",
        display: "flex",
        alignItems: isMobile ? "start" : "center",
        justifyContent: "space-between",
        gap: isMobile ? "12px" : "16px",
        zIndex: 1201, // 1 more than our sidebar.
        borderTopLeftRadius: !isMobile ? "16px" : undefined,
        marginBottom: !isMobile ? "-12px" : undefined,
        ...sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: "4px",
        }}
      >
        {isMobile && (
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              variant={isMobile ? "bodyHeavy" : "h5"}
              sx={{ color: "white" }}
            >
              Family Hub preview
            </Typography>
            <Typography
              variant={isMobile ? "bodyHeavy" : "h5"}
              sx={{ color: "white" }}
            >
              ({daysLeft} day{daysLeft !== 1 ? "s" : ""} left)
            </Typography>
          </Box>
        )}
        {!isMobile && (
          <Box sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              variant={isMobile ? "bodyHeavy" : "h5"}
              sx={{ color: "white" }}
            >
              Family Hub preview ({daysLeft} day{daysLeft !== 1 ? "s" : ""}{" "}
              left)
            </Typography>

            <Typography variant="body" sx={{ color: "white" }}>
              Your Family Hub keeps everything in one place: securely store
              info, get personalized task ideas, and see your tasks move
              forward.
            </Typography>
          </Box>
        )}
      </Box>

      <Button
        variant={isMobile ? "text" : "outlined"}
        size={isMobile ? "small" : "medium"}
        onClick={handleFinishSignup}
        endIcon={<ArrowRight size={20} />}
        fullWidth={isMobile}
        sx={{
          color: "white",
          borderColor: "white",
          whiteSpace: "nowrap",
          width: "auto",
        }}
      >
        Finish signup
      </Button>
    </Box>
  );
};
